module.exports = __webpack_public_path__ + "static/media/barclays.11cfa776.svg";